import { gql } from '@apollo/client'

export const GET_USER = gql`
  query ($id: Int) {
    getUser(id: $id) {
      email
      first_name
      last_name
      id
      label_id
      space_id
      unit_id
      country_code
      is_external
      role {
        role_id
        expire_at
      }
      assigned_campaigns {
        id
        artist {
          name
          spotify_id
          facebook_id
        }
        name
      }
    }
  }
`
